var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoadingTournament)?_c('div',{staticClass:"loading-tournament-wrapper"},[_c('b-spinner',{staticClass:"spinner"})],1):(_vm.templateComponent && !_vm.isLoadingTournament)?_c(_vm.templateComponent,{tag:"component"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }